export default __webpack_public_path__ + "static/singapore1a-a51cc6b467021b26ee2cc32e9eb243ad.png";